import { render } from "./AboutUs.vue?vue&type=template&id=4c4a5e35&scoped=true&ts=true"
import script from "./AboutUs.vue?vue&type=script&lang=ts"
export * from "./AboutUs.vue?vue&type=script&lang=ts"

import "./AboutUs.vue?vue&type=style&index=0&id=4c4a5e35&lang=scss&scoped=true"

import exportComponent from "E:\\vueapp\\xm-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c4a5e35"]])

export default __exports__